var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M13.093 3.025c-4.216 0-7.791 2.79-8.979 6.62L2.628 7.071 1 8.012l3.29 5.697 5.697-3.29-.94-1.628-3.259 1.881C6.58 7.37 9.55 4.905 13.093 4.905c4.146 0 7.52 3.373 7.52 7.52 0 4.145-3.374 7.519-7.52 7.519v1.88c5.183 0 9.4-4.216 9.4-9.4 0-5.182-4.217-9.399-9.4-9.399z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.f8cfc0b48e8efd8e27e02f962a42f085.svg";
export { ForwardRef as ReactComponent };